import { render, staticRenderFns } from "./AlertAliare.vue?vue&type=template&id=3c1c3199&scoped=true&"
import script from "./AlertAliare.vue?vue&type=script&lang=js&"
export * from "./AlertAliare.vue?vue&type=script&lang=js&"
import style0 from "./AlertAliare.vue?vue&type=style&index=0&id=3c1c3199&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c3199",
  null
  
)

export default component.exports